import { render, staticRenderFns } from "./AddPollQuestions.vue?vue&type=template&id=894f36e4&scoped=true&"
import script from "./AddPollQuestions.vue?vue&type=script&lang=js&"
export * from "./AddPollQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AddPollQuestions.vue?vue&type=style&index=0&id=894f36e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894f36e4",
  null
  
)

export default component.exports